import type MetaInterface from '@/interfaces/MetaInterface';

const Meta: MetaInterface = {
  version: __APP_VERSION__,
  date: __BUILD_DATE__,
};

export default Meta;
